import { GLOBAL } from '@/store/mutation-type'
const mutations = {
    'ERROR_MESSAGE': (state, _data) => {
        state.message = _data
    },
    [GLOBAL.ENV]: function (state, _data) {
        state.env = Object.assign(state.env || {}, _data)
        // console.log(state.env)
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js